import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../components/common/style.css';
import '../../components/common/responsive.css';
import './popupLogin.css'
import selsmartLogo from '../../assets/images/selsmart.png';
import GoogleLogo from '../../assets/images/Google_icon.png';
import FbLogo from '../../assets/images/fb_icon.png';
import { decryptData, encryptData, useUser } from '../../contexts/userContext';
import { RESEND_OTP_TIMEOUT } from '../../components/common/constant';
import { useRefresh } from '../../contexts/refreshLogin';

const PopupLogin: React.FC<any> = ({
    utmQuery
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isOtpFormVisible, setIsOtpFormVisible] = useState(false);
    const [otp, setOtp] = useState<string[]>(new Array(6).fill(''));
    const [mobileNo, setMobileNo] = useState('');
    const [emailset, setEmail] = useState<string | null>(null);
    const [isVerifyDisabled, setIsVerifyDisabled] = useState(true);
    const [showError, setShowError] = useState(false);

    const [loading, setLoading] = useState(false);
    const { setUserId, setUsername, setAuthToken, auth_token, user_id,fetchCsrfToken } = useUser();
    const nameInputRef = useRef<HTMLInputElement>(null);
    const [isRegisterVisible, setIsRegisterVisible] = useState(false);
    const [isRegisterComplete, setIsRegisterComplete] = useState(false); // New state to track registration completion
    const [currentView, setCurrentView] = useState<'login' | 'register' | 'verifyOtp'>('login');
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const [userIdd, setuserId] = useState<string | null>(null);
    const [seconds, setSeconds] = useState(0);
    const [isDisabled, setIsDisabled] = useState(true); // Disable resend button initially
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile_no: ''
    });

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        mobile_no: ''
    });

    const [error, setError] = useState<string | null>(null);
    const { setRefreshKey } = useRefresh();
    const nameInputReff = useRef<Array<HTMLInputElement | null>>([]);
    const nameInputRefff = useRef<HTMLInputElement>(null);
    // const nameInputRef = useRef<Array<HTMLInputElement | null>>([]);

    // useEffect(() => {
    //     setCurrentView('login')
    //     //console.log(nameInputRef.current,"asdfghursdfghhgfdsdfghgfdsdfghgfdfghgfdfg")
    //     if (nameInputRef.current) {
    //         //console.log(nameInputRef.current,"1234444")
    //         nameInputRef.current.focus();
    //     }
    //     // nameInputRef?.current?.focus();
    // });

    // useEffect(() => {
    //     if (currentView === 'login' && nameInputRef.current) {
    //         nameInputRef.current.focus();
    //     }
    // }, [currentView]);

    // useEffect(()=>{
    //     nameInputRef?.current?.focus();
    // })


    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === 'Backspace') {
            if (!otp[index] && index > 0) {
                nameInputReff.current[index - 1]?.focus();
            }
            const newOtp = [...otp];
            newOtp[index] = ''; // Clear current input
            setOtp(newOtp);
            setIsVerifyDisabled(true); // Disable Verify button on backspace
        }
    };


    const handleVerifyOtpRedirect = async () => {
        setShowError(false);
        if (!mobileNo || mobileNo.trim() === '') {
            setError('Please enter a 10 digits mobile number');
             // Clear error after 3 seconds
            return;
        }

        
        setIsOtpFormVisible(true);
        setLoading(true);
        
        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(
              `${backendUrl}api/v1/login?${utmQuery}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: JSON.stringify({ mobile_no: mobileNo }),
                
              }
            );

            const data = await response.json();
            if (data.result && data.result.id) {

                setUsername(data.result.name);
                setAuthToken(data.result.remember_token);
                setCurrentView('verifyOtp');
                setEmail(data.result.email)
                nameInputReff.current[0]?.focus();
                setuserId(data.result.id)
                // let timer: NodeJS.Timeout | undefined;
                // if (isDisabled && seconds > 0) {
                //     timer = setInterval(() => {
                        
                //         setSeconds(prev => prev - 1);
                //         // nameInputReff.current[0]?.focus();
                //     }, 1000);
                // }
                // Navigate after setting user context
                // navigate('/verify-otp', { state: { user_id: data.result.id, returnUrl, product, cart_id: cartId, session_code: session_code, slug: slug } });
            } else {
                setError(data.message || 'Either mobile no is not registered or its disabled');
                // setTimeout(() => setError(null), 3000); // Clear error after 3 seconds
            }
        } catch (err: any) {
            setError(err.message);
            // setTimeout(() => setError(null), 3000); // Clear error after 3 seconds
        } finally {
            setLoading(false);
        }
    };

    const handleclose = () => {

        setCurrentView('login');

        // window.location.reload()
    };

    const handleSignUp = () => {
        setIsRegisterVisible(true)
        setError(null)
        setCurrentView('register');
        //console.log(nameInputRefff.current)
        if (nameInputRefff.current) {
            nameInputRefff.current.focus();
        }
        nameInputRefff?.current?.focus();
    };

    const handleSignIn = () => {
        setIsRegisterVisible(false)
        setCurrentView('login');
        setError(null)  
        nameInputRef?.current?.focus();
    };

    const handleChangeReg = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        let updatedValue = value.trimStart();
        setError('')
        switch (name) {
            case 'name':
                updatedValue = updatedValue.replace(/[^a-zA-Z\s]/g, ''); // Only alphabets and spaces

                // Check if the value is empty or contains only spaces
                if (updatedValue.trim() === '') {
                    setErrors((prev) => ({ ...prev, name: 'Please enter the name' }));
                } else if (updatedValue.length > 50) {
                    setErrors((prev) => ({ ...prev, name: 'Name cannot exceed 50 characters' }));
                } else if (updatedValue.trim().length < 2) {
                    setErrors((prev) => ({ ...prev, name: 'Please enter at least 2 characters' }));
                } else {
                    setErrors((prev) => ({ ...prev, name: '' })); // Clear errors if valid
                }
                break;
            case 'email':
                updatedValue = updatedValue.replace(/\s/g, ''); // Remove spaces entirely

                if (updatedValue.trim() === '') {
                    setErrors((prev) => ({ ...prev, email: 'Please enter a valid email id' }));
                } else if (!/^[a-zA-Z0-9@._-]+$/.test(updatedValue)) {
                    setErrors((prev) => ({
                        ...prev,
                        email: 'Only alphabets, numbers, and special characters (@, ., -, _) are allowed',
                    }));
                } else if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(updatedValue)) {
                    setErrors((prev) => ({ ...prev, email: 'Please enter a valid email id' }));
                } else if (/^[0-9]+@/.test(updatedValue)) {
                    // Check if the part before @ is only numeric
                    setErrors((prev) => ({ ...prev, email: 'The part before @ cannot be only numeric' }));
                } else {
                    setErrors((prev) => ({ ...prev, email: '' })); // Clear error
                }
                break;

            case 'mobile_no':
                updatedValue = updatedValue.replace(/[^0-9]/g, '').slice(0, 14); // Only numbers, max length 10
                if (!updatedValue) {
                    setErrors((prev) => ({ ...prev, mobile_no: 'Please enter a valid mobile number' }));
                } else if (updatedValue === '0000000000') {
                    setErrors((prev) => ({ ...prev, mobile_no: 'Invalid mobile number' }));
                } else if (updatedValue.length < 10) {
                    setErrors((prev) => ({ ...prev, mobile_no: '10-digit required' }));
                } else if (updatedValue.length > 10) {
                    setErrors((prev) => ({ ...prev, mobile_no: 'Please enter a valid 10-digit mobile number' }));
                }else if (updatedValue.startsWith('0')) {
                    setErrors((prev) => ({ ...prev, mobile_no: 'Please check the number you have entered. It starts with "0".' }));
                } else {
                    setErrors((prev) => ({ ...prev, mobile_no: '' }));
                }
                break;

            default:
                break;
        }

        setFormData({
            ...formData,
            [name]: updatedValue,
        });
    };

    const isValidForm = () => {
        const isNameValid = formData.name.trim().length >= 2;
        const isEmailValid = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(formData.email);
        const isMobileValid = formData.mobile_no.length === 10;
        return isNameValid && isEmailValid && isMobileValid;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if(errors.mobile_no !== '' || null){
            return
        }

        if (!isValidForm()) {
            return; // Prevent submission if the form is invalid
        }

        setLoading(true);
        setError(null); // Clear any previous error
        
        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}api/v1/user/create?${utmQuery}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken,
                    
                 },
                 credentials: "include",
                body: JSON.stringify(formData),
                
            });

            const data = await response.json();

            if (response.ok) {
                if (data.result && data.result.id) {
                    setuserId(data.result.id);
                    setUsername(data.result.name);
                    setAuthToken(data.result.remember_token);
                    sessionStorage.setItem('mobileNumber', JSON.stringify(formData.mobile_no));
                    setCurrentView('verifyOtp');
                    let timer: NodeJS.Timeout | undefined;
                if (isDisabled && seconds > 0) {
                    timer = setInterval(() => {
                        setSeconds(prev => prev - 1);
                    }, 1000);
                }
                    // navigate('/verify-otp', {
                    //     state: { user_id: data.result.id, returnUrl, product, user: data.result, cart_id: cartId, session_code },
                    // });
                } else {
                    // Handle any unexpected structure in the response
                    setError(data.result?.message || 'Unexpected error occurred');
                }
            } else {
                // Handle error from the backend (non-2xx HTTP status)
                setError(data.result?.message || 'Registration failed');
            }
        } catch (error: any) {
            // Handle network or other unexpected errors
            setError(error.message || 'Something went wrong. Please try again later');
        } finally {
            setLoading(false);
        }
    };

    const handleOtpSubmit = async (otpValue: any) => {
        // const otpValue = otp.join('');
        if (otpValue.length !== 6) {
            setError('Please enter a 6-digit OTP');
            return;
        }
        // const userId = user_id
        
        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(
              `${backendUrl}api/v1/verify-otp?${utmQuery}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "auth-token": `${auth_token}`,
                  'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: JSON.stringify({ userId: userIdd, otp: otpValue }),
                
              }
            );

            const data = await response.json();
            
            if (data.data.success == true) {
                
                setUserId(userIdd);
                // localStorage.setItem("user_id", encryptData(userIdd));
                //console.log("user-----id", user_id, userIdd)

                localStorage.setItem('isLoggedIn', 'true');
                sessionStorage.removeItem('mobileNumber');
                setMobileNo('')
                otpValue = []
                setOtp(new Array(6).fill(''));
                setTimeout(() => {
                    setRefreshKey((prevKey: number) => prevKey + 1);
                    //console.log('Refresh triggered');
                }, 1000);
                const modalElement = document.getElementById('exampleModallogin');
                if (modalElement) {
                    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                    setCurrentView('login');
                }
               
                    document
                        .querySelectorAll(".modal-backdrop")
                        .forEach((backdrop) => backdrop.remove());
        
                     
                // navigate(returnUrl || '/', { state: { user_id: setUserId, returnUrl, product, cart_id: cartId, session_code: session_code } });
            } else {

                setOtp(new Array(6).fill(''));
                nameInputReff.current[0]?.focus();
                setError('Invalid OTP');
                // nameInputReff.current[0]?.focus();
            }
        } catch (err: any) {
            setOtp(new Array(6).fill(''));
            setError(err.message || 'An unexpected error occurred');
        }
    };

    const handleResendOtp = async () => {
        try {
            setIsDisabled(true);
            setSeconds(RESEND_OTP_TIMEOUT);
            const timer = setInterval(() => {
                setSeconds((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setIsDisabled(false); // Enable resend button
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            const userInfo = {
                id: userIdd,
                mobile_no: mobileNo,
                email: emailset
            }
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}api/v2/resend-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${auth_token}`,
                    'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: JSON.stringify({ userInfo }),
                
            });

            if (!response.ok) {
                throw new Error('Failed to resend OTP');
            }

            //console.log('OTP resent successfully');
            // Reset timer
            // Disable resend button
        } catch (error) {
            //console.error('Error resending OTP:', error);
            setError('Failed to resend OTP');
        }
    };

    const handleResendExpireOtp = async () => {
        try {
            // setIsDisabled(true);
            // setSeconds(RESEND_OTP_TIMEOUT);
            const userInfo = {
                id: userIdd,
                mobile_no: mobileNo,
                email: emailset
            }
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}api/v2/resend-otp-expire`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${auth_token}`,
                    'X-CSRF-Token': csrfToken,
                    
                },
                credentials: "include",
                body: JSON.stringify({ userInfo }),
                
            });

            if (!response.ok) {
                throw new Error('Failed to resend OTP');
            }

            //console.log('OTP resent successfully');
            // Reset timer
            // Disable resend button
        } catch (error) {
            //console.error('Error resending OTP:', error);
            setError('Failed to resend OTP');
        }
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/\D/g, ''); // Allow only numbers
        setMobileNo(value);
        setShowError(value.length > 0 && value.length < 10);
        if (mobileNo.startsWith('0') && value.length == 10 ) {
            // console.log("erororororoooooo")
            setError('Please enter a correct mobile number');
           // Clear error after 3 seconds
            return;
        }
        // Clear the error message when the user starts typing
        if (error) {
            setError(null);
        }
    };

    const handleFocus = () => {
        setError(null); // Clear error message on focus
    };

    useEffect(() => {
        let timer: NodeJS.Timeout | undefined;
    // console.log("secons-",seconds)
     if (seconds === 0 && isDisabled) { // Call only once when the button is disabled
            setIsDisabled(false); // Enable resend button
            if (currentView === 'verifyOtp') {
                handleResendExpireOtp();
            }
        }
    
        return () => {
            if (timer) {
                clearInterval(timer);
            }
        };
    }, [seconds]); // Depend on both `seconds` and `isDisabled`

    

    useEffect(() => {
        let timer: NodeJS.Timeout;
    
        if (!isDisabled) {
            // setSeconds(30); // Reset timer to 2 minutes
            // setIsDisabled(true); // Disable the resend button
    
            timer = setInterval(() => {
                setSeconds(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setIsDisabled(false); // Enable the resend button when timer reaches zero
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
    
        return () => clearInterval(timer); // Cleanup timer when component unmounts or currentView changes
    }, [!isDisabled]);

    

    useEffect(() => {
        let timer: NodeJS.Timeout;
    
        if (currentView === 'verifyOtp') {
            setSeconds(120); // Reset timer to 2 minutes
            setIsDisabled(true); // Disable the resend button
    
            timer = setInterval(() => {
                setSeconds(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setIsDisabled(false); // Enable the resend button when timer reaches zero
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
    
        return () => clearInterval(timer); // Cleanup timer when component unmounts or currentView changes
    }, [currentView ]);

    // useEffect(() => {
    //     if (isOtpFormVisible && seconds > 0) {
    //         const timer = setInterval(() => {
    //             setSeconds((prev) => {
    //                 if (prev <= 1) {
    //                     clearInterval(timer); // Clear interval when seconds reach 0
    //                     return 0;
    //                 }
    //                 return prev - 1;
    //             });
    //         }, 1000);
    
    //         return () => clearInterval(timer); // Cleanup on unmount or re-run
    //     }
    // }, [isOtpFormVisible, seconds]);
    
    

    // useEffect(() => {
    //     sessionStorage.removeItem("otpResent"); // Reset flag when view changes
    // }, [currentView]);



    const handleLogo = () => {
        navigate('/');
        window.scrollTo({ top: 0, behavior: 'smooth' })
    };

    useEffect(() => {
        const savedMobileNumber = sessionStorage.getItem('mobileNumber');
        if (savedMobileNumber) {
            setMobileNo(savedMobileNumber);
        }
    }, []);

    const handleChangeOtp = (element: HTMLInputElement, index: number) => {
        const value = element.value.replace(/\D/g, ''); // Allow only digits

        if (value.length === 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Enable "Verify OTP" button only when all 6 digits are filled
            const otpValue = newOtp.join('');

            setIsVerifyDisabled(otpValue.length !== 6);

            // Focus the next input if the current one is filled and it's not the last input
            if (index < otp.length - 1) {
                nameInputReff.current[index + 1]?.focus();
            }

            // Automatically verify OTP if all 6 digits are filled
            if (otpValue.length === 6) {
                //console.log("top============", otpValue, otpValue.length)
                handleOtpSubmit(otpValue); // Trigger OTP submit automatically
            }

        } else if (value === '') {
            // Handle backspace case by clearing the input
            const newOtp = [...otp];
            newOtp[index] = '';
            setOtp(newOtp);
            setIsVerifyDisabled(true); // Disable Verify button on backspace
        }
    };

    const convert_resend_button_timer = () => {
        const minutes = Math.floor(seconds / 60);
        const secondsRemaining = seconds % 60;
        return `${minutes.toString().padStart(2, '0')} m : ${secondsRemaining.toString().padStart(2, '0')} s`;
    };



    return (
        <div>

            <div className="container sign_inn-">
                <div className="row">
                    <div className="white_bg_right col-6-">
                        <div className="left-side popup-login">

                            <div className="auth-popup">
                                {currentView === 'login' && (

                                    <form id="loginForm" onSubmit={(e) => {
                                        e.preventDefault();
                                        // handleVerifyOtpRedirect();
                                    }}>
                                        <div>
                                            {/* <button  type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                               ></button> */}

                                        </div>
                                        <div className='pop_title'> Login</div>
                                        <p className="exact-value-popup">
                                            <span style={{ color: 'red' }}>*</span>
                                            <span style={{ color: 'red' }}>*</span>To get Exact Value.
                                        </p>
                                        <div className="input-group">
                                            <label>
                                                Mobile No.
                                                <p className="required">*</p>
                                            </label>
                                            <input
                                                type="text"
                                                className={`login-inputs ${showError && mobileNo.length > 0 ? 'error-msg' : ''}`}
                                                placeholder="+91-9999999999"
                                                ref={nameInputRef}
                                                onChange={handleChange}
                                                onFocus={handleFocus}
                                                maxLength={10}
                                                value={mobileNo}
                                                onKeyPress={(event) => {
                                                    if (event.key === 'Enter') {
                                                        handleVerifyOtpRedirect();
                                                    }
                                                }}
                                            />
                                            {showError && mobileNo.length > 0 && (
                                                <p className="error-message-popup">10 digits required</p>
                                            )}
                                        </div>

                                        {error && (
                                            <div className="error-login-page">
                                                {error.split('.').map((sentence, index) => (
                                                    <p className="error-message-popup" key={index}>
                                                        {sentence.trim()}
                                                        {index < error.split('.').length - 1 && '.'}
                                                    </p>
                                                ))}
                                            </div>
                                        )}

                                        <button
                                            className="login-button submit-btn"
                                            type="button"
                                            onClick={handleVerifyOtpRedirect}
                                            disabled={loading || mobileNo.length !== 10}
                                        >
                                            {loading ? 'Please wait...' : 'Send OTP'}
                                        </button>

                                        <p className="sign-up-link">
                                            Don't have an account?{' '}<a className='for_register' onClick={handleSignUp}> Sign Up</a>
                                            {/* <button type="button" className="sign-up-link-text" onClick={handleSignUp}>
                  Sign Up
              </button> */}
                                        </p>
                                    </form>
                                )}

                                {currentView === 'register' && (

                                    <form className="register-form" onSubmit={handleSubmit} >
                                        <div>
                                            {/* <button  type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                // onClick={handleclose}
                                aria-label="Close"></button> */}
                                        </div>
                                        <div className='pop_title'>Register</div>
                                        <div className="input-group">
                                            <label className="register-label">Your Name<p className="required">*</p></label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChangeReg}
                                                placeholder="Your name"
                                                ref={nameInputRefff}
                                                maxLength={50}
                                                className={`register-input ${errors.name ? 'input-error' : ''}`}
                                            />
                                            {errors.name && <span className="error-message-popup">{errors.name}</span>}
                                        </div>

                                        <div className="input-group">
                                            <label className="register-label">Mobile No.<p className="required">*</p></label>
                                            <input
                                                type="tel"
                                                name="mobile_no"
                                                value={formData.mobile_no}
                                                onChange={handleChangeReg}
                                                placeholder="+91-9999 999 999"
                                                maxLength={14}
                                                className={`register-input ${errors.mobile_no ? 'input-error' : ''}`}
                                            />
                                            {errors.mobile_no && <span className="error-message-popup">{errors.mobile_no}</span>}
                                        </div>
                                        <div className="input-group">
                                            <label className="register-label">E-Mail ID<p className="required">*</p></label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChangeReg}
                                                maxLength={50}
                                                placeholder="Example@email.com"
                                                className={`register-input ${errors.email ? 'input-error' : ''}`}
                                            />
                                            {errors.email && <span className="error-message-popup">{errors.email}</span>}
                                        </div>
                                        {error && (
                                            <div className="error-login-page">
                                                {error.split('.').map((sentence, index) => (
                                                    <p className="error-message-popup" key={index}>
                                                        {sentence.trim()}
                                                        {index < error.split('.').length - 1 && '.'}
                                                    </p>
                                                ))}
                                            </div>
                                        )}


                                        <button type="submit" className="register-button submit-btn" disabled={loading}>
                                            {loading ? 'Verifying...' : 'Register'}
                                        </button>

                                        <p className="sign-in-link">
                                            Already have an account?{' '}<a className='for_login' onClick={handleSignIn}>Sign In</a>

                                        </p>
                                    </form>
                                )}

                                {currentView === 'verifyOtp' && (
                                    <div className="otp-form">
                                        <div>

                                            {/* <button  type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                // onClick={handleclose}
                                aria-label="Close"></button> */}
                                {error && <p className="error-verify-fail">{error}</p>}
                                            <h3>Enter OTP</h3>
                                            <p className='psize'>
                  Please enter the six-digit OTP sent to <br />  (+91)-{
    mobileNo && !isNaN(Number(mobileNo)) && mobileNo.length === 10
      ? `${mobileNo.slice(0, 2)}xxxxxx${mobileNo.slice(-2)}`
      : '95-xxxxxx-89'
  }
                  
                </p>
                                        </div>

                                        <div className="otp-inputs">
                                            {otp.map((_, index) => (
                                                <input
                                                    key={index}
                                                    name={`otp-${index}`}
                                                    type="number"
                                                    maxLength={1}
                                                    placeholder='_'
                                                    value={otp[index]}
                                                    onFocus={handleFocus}
                                                    ref={(el) => (nameInputReff.current[index] = el)}
                                                    onChange={(e) => handleChangeOtp(e.target, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                />
                                            ))}
                                        </div>
                                        <div className="verify_Otp_btn_wrap">
                                            <div className="social-buttons">

                                                <button
                                                    className="btn btn-secondary- btn-outline-success re_send_otp"
                                                    onClick={handleResendOtp}
                                                    style={{
                                                        cursor: isDisabled ? "not-allowed" : "pointer",
                                                        // opacity: isDisabled ? 0.5 : 1,
                                                        display: isDisabled ? "none" : "block",
                                                    }}
                                                >
                                                    Resend OTP
                                                </button>
                                                <button
                                                    className="btn btn-success verify_Otp"
                                                    onClick={handleOtpSubmit}
                                                    disabled
                                                    style={{ display: 'none' }} // Hide the button as it's not needed
                                                >
                                                    Verify OTP
                                                </button>


                                            </div>
                                        </div>
                                        <p className="trouble_otp">Trouble in getting OTP?</p>
                                        <p className="chk_mobile_no">
                                            Make sure you entered the correct mobile number.
                                        </p>

                                        <div className="otptext">
                                            {/* <p className="info">An OTP has been sent to your Mobile No.</p> */}
                                            <p className="request">
                                                {isDisabled
                                                    ? `Request new OTP in ${convert_resend_button_timer()}`
                                                    : "You can request a new OTP"}
                                            </p>
                                        </div>
                                        {/* {!isDisabled && (
                    <div
                      className="linkResendotp"
                      onClick={handleResendOtp}
                      style={{
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.5 : 1,
                      }}
                    >
                      RESEND OTP
                    </div>
                  )} */}
                                        
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupLogin;
